import React, { useState } from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import Badge from '../components/ui/Badge';

export default function DeepDives() {
  const [activeTab, setActiveTab] = useState('feed');

  const tabs = [
    { id: 'feed', name: 'The Pitch Feed' },
    { id: 'score', name: 'ScoreWidget' },
    { id: 'tv', name: 'Fodbold TV' }
  ];

  return (
    <section>
      <SectionHeader id="deep-dives" title="3. Product Deep Dives" subtitle="Everything you need to know about each solution." />
      
      <div className="flex space-x-2 border-b border-slate-700 mb-6 overflow-x-auto">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 font-medium text-sm rounded-t-lg transition-colors whitespace-nowrap ${
              activeTab === tab.id 
                ? 'bg-blue-600 text-white' 
                : 'text-slate-400 hover:text-white hover:bg-slate-800'
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {activeTab === 'feed' && (
        <div className="space-y-6 animate-fadeIn">
          <div className="bg-slate-800 p-6 rounded-xl border border-slate-700">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-2xl font-bold text-white">The Pitch Feed</h3>
              <Badge type="confirmed">Core Product</Badge>
            </div>
            <p className="text-slate-300 text-lg mb-4 font-semibold">Access to 40+ Football News Stories Per Day.</p>
            <p className="text-slate-400 text-sm mb-6">A continuous stream of ready-to-publish sports content. It combines sourced news from external partners with our own proprietary editorial input and 100% original stories.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-blue-400 font-bold mb-2">The Value Pillar</h4>
                <ul className="list-disc pl-5 space-y-1 text-slate-300 text-sm">
                  <li><Badge type="confirmed">Volume</Badge> 40+ stories/day ensures you cover every major angle.</li>
                  <li><Badge type="confirmed">Process</Badge> Sourced news + Editorial enhancement + Original stories.</li>
                  <li><Badge type="recommended">Efficiency</Badge> Cheaper and faster than hiring a weekend shift or night desk.</li>
                </ul>
              </div>
              <div>
                <h4 className="text-amber-400 font-bold mb-2">Commercial Guardrails</h4>
                <ul className="list-disc pl-5 space-y-1 text-slate-300 text-sm">
                  <li><Badge type="danger">NO FREE TRIAL</Badge> Due to technical and content costs.</li>
                  <li><Badge type="recommended">PROOF POINT</Badge> Direct prospects to <a href="https://thepitchfeed.com/news" target="_blank" className="text-blue-400 underline">thepitchfeed.com/news</a> to see quality.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'score' && (
        <div className="space-y-6 animate-fadeIn">
          <div className="bg-slate-800 p-6 rounded-xl border border-slate-700">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-2xl font-bold text-white">ScoreWidget</h3>
              <Badge type="confirmed">Engagement Product</Badge>
            </div>
            <p className="text-slate-300 text-lg mb-6">Drop-in UI components for live scores, fixtures, and standings.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-blue-400 font-bold mb-2">Why Buyers Care</h4>
                <ul className="list-disc pl-5 space-y-1 text-slate-300 text-sm">
                  <li><Badge type="confirmed">Time on Page</Badge> Live updating scores keep users staring at the screen.</li>
                  <li><Badge type="confirmed">Zero Dev Effort</Badge> Just paste a code snippet; no complex APIs to manage.</li>
                </ul>
              </div>
              <div>
                <h4 className="text-purple-400 font-bold mb-2">Cross-sell Play</h4>
                <p className="text-sm text-slate-300 italic">"You have the news (Feed), now turn your articles into a live match center with ScoreWidget."</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'tv' && (
        <div className="space-y-6 animate-fadeIn">
          <div className="bg-slate-800 p-6 rounded-xl border border-slate-700">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-2xl font-bold text-white">Fodbold TV Guide</h3>
              <Badge type="verify">Niche / Localized Product</Badge>
            </div>
            <p className="text-slate-300 text-lg mb-6">Localized schedules for football broadcasts.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-blue-400 font-bold mb-2">Primary Angle</h4>
                <p className="text-sm text-slate-300">Captures high-intent search traffic for "where to watch" queries. Best for affiliates and local publishers.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}